import driverActions from "../actionTypes/driver";
import actions from "../actionTypes/index";

export const resetAllForms = () => ({
  type: driverActions.DRIVER_RESET_FORMS
});

export const getDriverAddressForm = payload => ({
  type: driverActions.DRIVER_ADDRESS_DETAILS_FORM,
  payload
});

export const driverAdditionalForm = payload => ({
  type: driverActions.DRIVER_ADDITIONAL_DETAILS_FORM,
  payload
});

export const getDriverAttachmentsDetails = payload => ({
  type: driverActions.DRIVER_ATTACHMENT_DETAILS,
  payload
});

export const getDriverLicenseDetails = payload => ({
  type: driverActions.DRIVER_LICENSE_DETAILS_FORM,
  payload
});

export const getQualificationDetails = payload => ({
  type: driverActions.DRIVER_QUALIFICATION_DETAILS_FORM,
  payload
});

export const getLicenceAdditionalDetails = payload => ({
  type: driverActions.DRIVER_LICENCE_FORM,
  payload
});

export const getPayrollDetails = payload => ({
  type: driverActions.DRIVER_PAYROLL_FORMS,
  payload
});

export const getPreferenceDetails = payload => ({
  type: driverActions.DRIVER_PREFERENCE_FORMS,
  payload
});

export const getHumanResource = payload => ({
  type: driverActions.DRIVER_HUMAN_RESOURCE,
  payload
});

export const getRatings = payload => ({
  type: driverActions.DRIVER_RATINGS_FORMS,
  payload
});

export const getInfringements = payload => ({
  type: driverActions.DRIVER_INFRINGEMENTS_FORMS,
  payload
});

export const getNotesForm = payload => ({
  type: driverActions.DRIVER_NOTES_FORMS,
  payload
});

export const getPerformanceForm = payload => ({
  type: driverActions.DRIVER_PERFORMANCE_FORMS,
  payload
});

export const getTasksForm = payload => ({
  type: driverActions.DRIVER_TASKS_FORMS,
  payload
});

export const getSmartBoxForm = payload => ({
  type: driverActions.DRIVER_SMART_BOX_FORM,
  payload
});

export const clearDetailsForm = () => ({
  type: actions.CANDIDATE_DETAILS_CLEAR
});

export const clearContactsForm = () => ({
  type: actions.CONTACT_DETAILS_CLEAR
});

export const clearPayrollDetails = () => ({
  type: actions.GET_PAYROLL_DETAILS_CLEAR
});

export const clearHRDetails = () => ({
  type: actions.GET_HUMAN_RESOURCE_CLEAR
});

export const clearSendAvailabilityRequest = () => ({
  type: actions.SEND_AVAILABILITY_REQUEST_CLEAR
});

export const clearSendNoWorkTomorrow = () => ({
  type: actions.SEND_NO_WORK_TOMORROW_CLEAR
});
export const clearSendCalendarUpdated = () => ({
  type: actions.SEND_CALENDAR_UPDATED_CLEAR
});

export const clearSendCalendarSummary = () => ({
  type: actions.SEND_CALENDAR_SUMMARY_CLEAR
});

export const clearSendBookingDetails = () => ({
  type: actions.SEND_BOOKING_DETAILS_CLEAR
});

export const clearSendBookingHoursQuery = () => ({
  type: actions.SEND_BOOKING_HRS_CLEAR
});

export const clearSendSMSToPhoneNumber = () => ({
  type: actions.SEND_SMS_TO_PHONE_NUMBER_CLEAR
});

export const clearRequestRtwCheck = () => ({
  type: actions.REQUEST_RTW_CHECK_CLEAR
});

export const clearDrivingLicenseInfo = () => ({
  type: actions.ADD_DRIVING_LICENSE_CLEAR
});

export const addPersonToLBAPI = payload => ({
  type: actions.ADD_PERSON_TO_LBAPI,
  payload
});
